import { sendPageview } from 'dpl/util/analytics';

export function trackPageView({ name, category }) {
  sendPageview(
    {
      page_title: document.title,
      page_path: `${window.location.pathname}${window.location.search}`,
      page_location: window.location.href
    },
    { name, category }
  );
}
